import React, {useEffect, useMemo } from "react";
import {Container, CustomProvider, Loader} from 'rsuite'
import {useDispatch, useSelector} from "react-redux";
import ResumeSideNav from "./components/nav/ResumeSideNav";

import './css/App.css';
import 'rsuite/dist/rsuite.min.css';
import Login from "./components/pages/Login";
import {getCurrentUser} from "./service/authService";
import {setAuthenticated, setCurrentUser, setLoading, setUserInfo} from "./redux/userSlice";
import {getOrCreateUser} from "./service/userService";
import HeaderNav from "./components/nav/HeaderNav";
import useLocalStorage from "react-use-localstorage";

// if not authenticated show login page
// once a user login their info is available from /api/users/me and we will set that in redux
// for the rest of the app to use
function App() {
    const dispatch = useDispatch();
    const authenticated = useSelector((state) => state.user.authenticated );
    const loading = useSelector((state) => state.user.loading );
    const [theme] = useLocalStorage('theme', 'dark');

    useEffect(() => {
        dispatch(setLoading(true));
            getCurrentUser().then((data) => {
                if (data !== null && data !== undefined){
                    dispatch(setCurrentUser(data));
                    const userPayload = {
                      email: data.email,
                      firstName: data.given_name,
                      lastName: data.family_name,
                      sellStatement: '',
                    };
                    // avoid account not existing issues, force creation if they do not exist
                    getOrCreateUser(userPayload).then((userInfo) => {
                        dispatch(setUserInfo(userInfo));
                        dispatch(setAuthenticated(true));
                        dispatch(setLoading(false));
                    })
                }
            });
        },[dispatch]
    );

    return useMemo(() => {
        return (
            <CustomProvider theme={theme}>
                <div>
                    {loading  ?  <Loader content="Loading..." size="lg" vertical center /> :
                        authenticated ?
                            <>
                                <HeaderNav />
                                <Container>
                                    <ResumeSideNav />
                                </Container>
                            </>
                            :
                            <Login />}
                </div>
            </CustomProvider>
        );
    }, [authenticated, loading, theme]);
}

export default App;
